import { useQuery } from "@tanstack/react-query";
import { projectService } from "@/services/projectService";
import { Project } from "@/types/types";

export const useProjectsData = () => {
  const {
    data: projects = [],
    isLoading,
    isError,
    error,
  } = useQuery<Project[], Error>({
    queryKey: ["projects"],
    queryFn: projectService.getProjects,
    staleTime: 1000 * 60 * 60 * 24 * 7, // 7 days
  });

  // Calculate stats
  const totalProjects = projects.length;
  const completedProjects = projects.filter(
    (p) => p.status === "completed"
  ).length;
  const inProgressProjects = projects.filter(
    (p) => p.status === "in-progress"
  ).length;
  const waitingProjects = projects.filter((p) => p.status === "paused").length;
  const teamProgress =
    projects.length > 0
      ? Math.round((completedProjects / totalProjects) * 100)
      : 0;

  return {
    projects,
    isLoading,
    isError,
    error,
    stats: {
      totalProjects,
      completedProjects,
      inProgressProjects,
      waitingProjects,
      teamProgress,
    },
  };
};
